var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "wf-page-controls" }, [
      _c("div", { staticClass: "wf-page-controls-items" }, [
        _c(
          "div",
          {
            staticClass:
              "wf-page-control-item wf-page-control-item-current-refinements"
          },
          [_c("pc-page-nav-back-button")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "wf-page-control-item wf-page-control-item-product-display-controls"
          },
          [
            _c("wf-product-display-controls", {
              attrs: { "show-size-control": false, "show-sort-control": false }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "vue-collections-search-container" } },
      [
        _c("pc-collections-search-container", {
          attrs: { "collection-code": _vm.initialCollectionCode }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }